import { enumToStaticValue } from '@/utils'

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  WEB = 'WEB'
}

export const contactTypes = enumToStaticValue(ContactType, 'contact-type')
